import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation } from "swiper";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import "swiper/css";
import "swiper/css/navigation";

const HeroBanner = ({ user, seller }) => {
  SwiperCore.use([Autoplay]);
  const navigate = useNavigate();

  const slides = [
    {
      title: "Discover Exotic Animals, Plants & Minerals",
      subtitle:
        "The marketplace connecting breeders with enthusiasts nationwide",
      buttonText: "Browse Listings",
      buttonAction: () => navigate("/listings"),
      bgImage: "https://images.unsplash.com/photo-1497752531616-c3afd9760a11?w=1400&q=80",
    },
    {
      title: "Start Selling Today",
      subtitle:
        "Reach thousands of buyers with your own storefront and featured listings",
      buttonText:
        user && seller?.approval_status === "approved"
          ? "Seller Dashboard"
          : "Become a Seller",
      buttonAction: () =>
        user && seller?.approval_status === "approved"
          ? navigate("/seller/dashboard")
          : navigate("/pricing"),
      bgImage: "https://images.unsplash.com/photo-1437622368342-7a3d73a34c8f?w=1400&q=80",
    },
    {
      title: "Selectively Bred Captive Animals",
      subtitle:
        "Verified breeders, detailed genetics, and safe transactions",
      buttonText: "Explore Categories",
      buttonAction: () => navigate("/classes"),
      bgImage: "https://images.unsplash.com/photo-1546026423-cc4642628d2b?w=1400&q=80",
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: "340px", sm: "420px", md: "490px" },
        overflow: "hidden",
      }}
    >
      <Swiper
        modules={[Navigation]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        navigation={true}
        loop={true}
        style={{
          height: "100%",
          "--swiper-navigation-color": "#FFC001",
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                height: "100%",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {/* Blurred background image */}
              <Box
                sx={{
                  position: "absolute",
                  inset: "-40px",
                  backgroundImage: `url(${slide.bgImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  filter: "blur(8px) brightness(0.35)",
                  zIndex: 0,
                }}
              />
              {/* Content */}
              <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
                <Box sx={{ textAlign: "center", px: { xs: 2, md: 4 }, pt: { xs: 4, sm: 5, md: 6 } }}>
                  <Typography
                    sx={{
                      color: "#FFC001",
                      fontWeight: 700,
                      fontSize: { xs: "20px", sm: "28px", md: "36px", lg: "42px" },
                      lineHeight: 1.2,
                      mb: 1,
                      textShadow: "0 2px 8px rgba(0,0,0,0.6)",
                    }}
                  >
                    {slide.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#ddd",
                      fontSize: { xs: "12px", sm: "14px", md: "16px" },
                      mb: { xs: 1.5, md: 2.5 },
                      maxWidth: "600px",
                      mx: "auto",
                      textShadow: "0 1px 4px rgba(0,0,0,0.5)",
                    }}
                  >
                    {slide.subtitle}
                  </Typography>
                  <Button
                    onClick={slide.buttonAction}
                    sx={{
                      backgroundColor: "#FFC001",
                      color: "#000",
                      fontWeight: 600,
                      px: { xs: 3, md: 4 },
                      py: { xs: 0.8, md: 1.2 },
                      fontSize: { xs: "12px", md: "14px" },
                      borderRadius: "8px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#e6ac00",
                      },
                    }}
                  >
                    {slide.buttonText}
                  </Button>
                </Box>
              </Container>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

const mapStateToProps = ({ Auth, Seller }) => ({
  user: Auth.user,
  seller: Seller?.seller,
});

export default connect(mapStateToProps)(HeroBanner);
